import { render, staticRenderFns } from "./add-device-gdpr.vue?vue&type=template&id=26d1b1d0&scoped=true&"
import script from "./add-device-gdpr.js?vue&type=script&lang=js&"
export * from "./add-device-gdpr.js?vue&type=script&lang=js&"
import style0 from "./add-device-gdpr.css?vue&type=style&index=0&id=26d1b1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d1b1d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
